<template>
  <div>
    <form-cad-cliente
      @MensagemGravaSucesso="showSucesso($event)"
      @gravacaoOkCliente="buscaUsuarios"
      @getCadCliente="getErroCadCliente($event)"
      @fechaDialog="fechaDialog"
      :dialog="selDialog"
    ></form-cad-cliente>

    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Editar Cliente</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="edituser.nome" label="Nome" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="edituser.telefone"
                  label="Telefone"
                  hint="Utilizar somente números ex:3199999999"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="CPF"
                  mask="###########"
                  :rules="cnpjRules"
                  counter="11"
                  v-model="edituser.cpf_cnpj"
                  hint="Utilizar somente números"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field v-model="edituser.email" name="email" label="E-mail" value></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="170"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    outline
                    slot="activator"
                    v-model="dataNascimentoFormatted"
                    label="Data Nascimento"
                    readonly
                    persistent-hint
                    prepend-icon="event"
                    required
                    clearable
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    locale="pt-br"
                    v-model="edituser.data_nascimento"
                    no-title
                    @change="save"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1930-01-01"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*Campos requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-progress-circular v-show="progresso" indeterminate color="primary"></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn class="white--text" color="terciary" @click.native="dialog=false">Cancelar</v-btn>
          <v-btn class="white--text" color="sucesso" @click.native="atualizar()">Gravar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap>
        <v-flex xs12>
          <v-progress-linear color="carregando" v-show="loading" :indeterminate="true"></v-progress-linear>
          <v-card class="Black--text" color="card">
            <v-card-title primary-title>
              <div class=".pa-1 text-md-left headline">Clientes</div>
            </v-card-title>
            <v-card-title>
              <v-flex xs6>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>

              <v-flex xs3>
                <v-btn
                  class="white--text"
                  @click="pdf()"
                  id="btnPDF"
                  ref="btnPDF"
                  color="orange"
                  value="justify"
                >
                  PDF
                  <v-icon right>tab</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn class="white--text" @click="novo()" color="sucesso">
                  Novo
                  <v-icon dark right>add</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-spacer></v-spacer>

            <v-data-table
              v-show="true"
              sort-field="nome"
              :headers="headers"
              :items="items"
              :loading="false"
              :search="search"
              :disable-initial-sort="true"
              rows-per-page-text="registros por página"
              no-data-text="Nenhum resultado encontrado!"
              no-results-text="Nenhum resultado encontrado!"
              class="elevation-3"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">{{ props.header.text }}</span>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.cpf_cnpj }}</td>
                <td class="text-xs-left">{{props.item.cartao}}</td>
                <td class="text-xs-left">{{ props.item.nome }}</td>
                <td class="text-xs-right">{{props.item.telefone}}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>

                <td class="text-xs-right">{{props.item.data_cadastro}}</td>
                <td class="text-xs-right">{{props.item.ultima_movimentacao}}</td>
                <td class="text-xs-right">{{props.item.saldo}}</td>
                <!-- <v-tooltip v-show="props.item.cartao == 'T'" top>
                    <v-icon slot="activator" color="green darken-2" center>check_circle</v-icon>
                    <span>Com cartão</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-icon
                      slot="activator"
                      v-show="props.item.cartao == 'F'"
                      color="red darken-2"
                      center
                    >check_circle</v-icon>
                    <span>Sem cartão</span>
                  </v-tooltip>
                </td>-->
                <td class="text-xs-center">
                  <v-btn color="black" @click="edit( props.item)" flat icon small>
                    <v-icon center>edit</v-icon>
                  </v-btn>
                </td>
              </template>
              <template
                slot="pageText"
                slot-scope="props"
              >de{{ props.pageStart }} até {{ props.pageStop }} de {{ props.itemsLength }}</template>
            </v-data-table>
          </v-card>
        </v-flex>
        <a href="#" target="_blank" id="linkDownload" download></a>
      </v-layout>

      <v-snackbar
        :timeout="tempo"
        :color="error"
        :multi-line="'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ textSnack }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
const FormCadCliente = () => import("@/components/FormCadCliente");

var moment = require("moment");

export default {
  mixins: [formata],
  mounted() {
    this.buscaUsuarios();
  },
  components: {
    FormCadCliente
  },
  data: () => ({
    snackbarSuccess: false,
    snackSucesso: "",
    textSucesso: "",
    textSnack: "",
    snackbar: false,
    dialog: false,
    dataIn: moment().format("YYYY-MM-01"),
    extrato: [],
    search: "",
    mode: "",
    error: "",
    textSnack: "",
    tempo: 0,
    snackbar: "",
    selDialog: false,
    loading: false,
    mostraConvenios: false,

    dataNascimentoFormatted: "",
    menu: false,
    menu2: false,
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: moment().format("DD/MM/YYYY"),

    edituser: {
      nome: "",
      cpf_cnpj: "",
      email: "",
      id: "",
      telefone: "",
      cartao: "",
      data_nascimento: ""
    },
    progresso: false,
    headers: [
      {
        text: "CPF",
        value: "cpf_cnpj"
      },
      {
        text: "Cartão",
        value: "cartao"
      },
      {
        text: "Nome",
        value: "nome"
      },
      {
        text: "Telefone",
        value: "telefone"
      },

      {
        text: "Email",
        value: "email"
      },
      {
        text: "Cadastro",
        value: "data_cadastro"
      },
      {
        text: "Ultima Movimentação",
        value: "ultima_movimentacao"
      },
      {
        text: "Saldo",
        value: "saldo"
      },

      {
        text: "Ações",
        value: "operacao",
        align: "center",
        sortable: false
      }
    ],

    items: [],
    cnpjRules: [
      v => !!v || "CPF é requerido",
      v => v.length == 11 || "CPF  Menor que o padrão"
    ]
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    dataNascimentoFormatted(val) {
      if (val == null) {
        this.edituser.data_nascimento = "";
      }
    },
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },

  methods: {
    save(data) {
      console.log("save" + data);
      this.dataNascimentoFormatted = this.formatDate(
        this.edituser.data_nascimento
      );
      /*  = this.parseDate(
        this.dataNascimentoFormatted
      );*/
    },
    getErroCadCliente(texto) {
      this.textSnack = texto;
      this.snackbar = true;
    },
    showSucesso(texto) {
      this.textSucesso = texto;
      this.snackbarSuccess = true;
    },
    fechaDialog() {
      this.selDialog = false;
    },
    pdf() {
      this.loading = true;
      HTTP.get(`users/pdf`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loading = false;
      });
    },
    fieldFn(rowObj) {
      console.log(rowObj);
      return rowObj.operacao;
      if (rowObj.operacao == "C") {
        return "positivo";
      } else {
        return "negativo";
      }
    },
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    edit(row) {
      this.dialog = true;
      // console.log(row);
      this.edituser.id = row.id;
      this.edituser.nome = row.nome;
      this.edituser.cpf_cnpj = row.cpf_cnpj;
      this.edituser.cartao = row.cartao;
      this.edituser.email = row.email;
      this.edituser.telefone = row.telefone;
      this.edituser.data_nascimento = row.data_nascimento;

      this.dataNascimentoFormatted = this.formatDate(row.data_nascimento);
    },
    atualizar() {
      this.progresso = true;

      HTTP.put(`users/atualizar/` + this.edituser.id, this.edituser)
        .then(response => {
          console.log(response.data);
          if (response.data.error != "") {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.textSnack = "Gravado com sucesso!";
            this.snackbar = true;
            this.dialog = false;

            //this.extrato =
            //  console.log(response.data);
            //   this.items = response.data;
            // this.mostraConvenios = true;
          }
          this.progresso = false;
          this.buscaUsuarios();
        })
        .catch(e => {
          //this.loading = false;
          this.progresso = false;

          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            this.textSnack = itens.join("");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });
    },
    buscaLojasPdf() {
      this.loading = true;
      HTTP.get(
        `movimentacao/loja/pdf` + "/" + this.dataIn + "/" + this.dataFim
      ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loading = false;
      });
    },
    buscaUsuarios(dataIn, dataFim) {
      this.loading = true;
      HTTP.get(`users/lista`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =
          console.log(response.data);
          this.items = response.data;
          // this.mostraConvenios = true;
        }
        this.loading = false;
      });
    },
    novo() {
      this.convenio = "";
      this.selDialog = true;
    },
    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/Usuario.vue